"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightedTextField = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const useStyles = (0, styles_1.makeStyles)({
    wrapper: {
        lineHeight: '1.1876em',
        fontWeight: 500,
        padding: '2pt',
        fontSize: 14,
    },
});
function HighlightedTextField({ highlightedContent, }) {
    const classes = useStyles();
    return react_1.default.createElement("div", { className: classes.wrapper }, highlightedContent);
}
exports.HighlightedTextField = HighlightedTextField;
//# sourceMappingURL=highlighted-text-field.js.map